import { useNavigate } from 'react-router-dom';
import { GroupView } from '../elements/group/GroupView';
import { EPageViewType, Group } from '../types';
import { EnvironmentVariables } from '../EnvironmentVariables';
import axios from 'axios';
import React from 'react';
import { PageHeading } from '@portal_components/components/PageHeading';
import { useQueryClient } from '@tanstack/react-query';
import { useUserInfo } from '../hooks/useUserInfo';
import { EUserRole } from '@portal_components/types';

export const AddGroupPage = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const { userInfo } = useUserInfo();
  const [formSubmitted, setFormSubmitted] = React.useState<boolean>(false);

  const handleSubmit = async (values: Partial<Group>): Promise<{ success: boolean; message: string }> => {
    setFormSubmitted(true);
    const response = await axios
      .put(`${EnvironmentVariables.ApiUrl}/group`, values, {
        headers: {
          'Content-Type': 'application/json'
        },
        withCredentials: true
      })
      .catch(error => error.response);
    if (!response) {
      setFormSubmitted(false);
      return { success: false, message: 'An error occurred while adding group.' };
    }
    if (response.status !== 200) {
      setFormSubmitted(false);
      return { success: false, message: response.data };
    }
    queryClient.resetQueries({ queryKey: ['search-groups'] });
    setTimeout(() => {
      navigate(`/`);
    }, 5000);
    return {
      success: true,
      message: 'Successfully added group. You will be automatically redirected to the main page'
    };
  };

  if (!userInfo || userInfo.role === EUserRole.READONLY_USER)
    return <p className="text-center">You do not have permission to add customer groups.</p>;

  return (
    <div>
      <PageHeading title="Add Group" />
      <GroupView
        viewType={EPageViewType.ADD}
        group={{}}
        onSubmit={handleSubmit}
        formSubmitted={formSubmitted}
      />
    </div>
  );
};
